export function StatPill({ children }) {
  return (
    <span className="rounded bg-slate-800 px-2 py-0.5 text-xs font-medium text-slate-200">
      {children}
    </span>
  );
}
